export const MODE = {
  new: 'new',
  edit: 'edit',
  view: 'view',
};
